import { Routes } from '@angular/router';
import { Login } from './views/login/login';
import { Home } from './views/home/home';
import { Overview } from './views/home/overview/overview';
import { Store } from './views/home/store/store';

import { Chat } from './views/home/chat/chat';
import { Splash } from './views/splash/splash';
import { News } from './views/home/news/news';
import { Library } from './views/home/library/library';
import { Rankings } from './views/home/rankings/rankings';

import { Help } from './views/home/help/help';

export const routes: Routes = [
    { path: '', redirectTo: 'login', pathMatch: 'full' },
    { path: 'login', component: Login },
    {
        path: 'home', component: Home, children: [
            { path: 'overview', component: Overview, data: { title: 'HOME' } },
            { path: 'chat', component: Chat, data: { title: 'LOBBY', noPadding: true } },
            { path: 'chat/:id', component: Chat, data: { title: 'LOBBY', noPadding: true } },
            { path: 'store', component: Store },
            { path: 'library', component: Library, data: { title: 'LIBRARY' } },
            { path: 'rankings', component: Rankings, data: { title: 'RANKINGS' } },
            { path: 'news/:id', component: News, data: { title: 'NEWS' } },
            { path: 'help', component: Help, data: { title: 'HELP & FAQ' } },
        ]
    },
    { path: 'splash', component: Splash }
];

